import moment from "moment";
import type { Parcel } from "src/pages/dashboard/HistoricPayments";
import axiosInstance from "src/utils/axios";
import {
  BoletoUnicoParams,
  NegociacaoBoletoUnico,
  SimulacaoBoletoUnico,
  TituloBoletoUnico,
  negociacaoFromJson,
  simulacaoFromJson,
} from "src/@types/boletoUnico";

export async function consultar(contractNumber: string): Promise<NegociacaoBoletoUnico[]> {
  try {
    const { data } = await axiosInstance.get(
      `/boleto-unico/consultar?contract_number=${contractNumber}`
    );
    const negociacoes = data?.negociacoes;
    return Array.isArray(negociacoes) ? negociacoes.map(negociacaoFromJson) : [];
  } catch (error) {
    throw new Error("Não foi possível consultar a negociação.");
  }
}

export async function simular(params: BoletoUnicoParams): Promise<SimulacaoBoletoUnico> {
  try {
    const { data } = await axiosInstance.post("/boleto-unico/simular", params);
    return simulacaoFromJson(data);
  } catch (error) {
    throw new Error(
      "Não foi possível simular a negociação.\nPor favor, tente novamente mais tarde ou entre em contato conosco."
    );
  }
}

export async function gerar(params: BoletoUnicoParams): Promise<NegociacaoBoletoUnico> {
  const erro =
    "Não foi possível gerar negociação\nPor favor, tente novamente mais tarde ou entre em contato conosco.";
  let negociacao: any;
  try {
    const { data } = await axiosInstance.post("/boleto-unico/gerar", params);
    negociacao = data?.negociacao;
  } catch (error) {
    throw new Error(erro);
  }

  if (!negociacao) throw new Error(erro);

  return negociacaoFromJson(negociacao);
}

// ----------------------------------------------------------------------

/**
 * Parcelas em atraso do contrato no ano corrente.
 * Atraso = não paga e vencida há mais de um dia (mesma regra do app).
 */
export async function buscarParcelasEmAtraso(
  userId: string | number,
  contractNumber: string
): Promise<Parcel[]> {
  const ano = new Date().getFullYear();
  const { data } = await axiosInstance.get(
    `/users/listHistoric/${userId}?contract_number=${contractNumber}&year=${ano}`
  );

  const parcelas: Parcel[] = Array.isArray(data) ? data : [];
  const ontem = moment().subtract(1, "day");

  return parcelas.filter((p) => p.status !== "PAGO" && moment(p.due_date).isBefore(ontem, "day"));
}

export const parcelaParaTitulo = (p: Parcel): TituloBoletoUnico => ({
  prefixo: p.prefix ?? "",
  numero: p.num ?? "",
  parcela: p.installment ?? "",
  tipo: p.type ?? "",
});

